import { MutationTree } from 'vuex';
import { FlowDesignerState } from '..';
import { ADD_STATE, REMOVE_STATE, REMOVE_TRANSITION, UPDATE_STATE } from './mutationTypes';
import { StateViewModel } from '@/features/bots/models/designer';

export const mutations: MutationTree<FlowDesignerState> = {
  [ADD_STATE](state, newState: StateViewModel) {
    const pathToUpdate = state.currentFlow.paths.find((p) => p.id === state.currentPathId);
    if (pathToUpdate === undefined) {
      return;
    }

    if (pathToUpdate.states.length > 0) {
      const lastState = pathToUpdate.states[pathToUpdate.states.length - 1];

      // last state is an end state, so insert the new state at the penultimate index
      // keeping the end state as the last entry
      if (lastState.component === 'HumanHandover' || lastState.component === 'GoTo') {
        pathToUpdate.states.splice(pathToUpdate.states.length - 1, 0, newState);
        return;
      }
    }
    pathToUpdate.states.push(newState);
  },

  [REMOVE_STATE](state, stateToRemove: StateViewModel) {
    const pathToUpdate = state.currentFlow.paths.find((p) => p.id === state.currentPathId);
    if (pathToUpdate === undefined) {
      return;
    }
    const stateIndexToRemove = pathToUpdate.states.findIndex((s) => s.id === stateToRemove.id);
    if (stateIndexToRemove === -1) {
      return;
    }
    pathToUpdate.states.splice(stateIndexToRemove, 1);
  },

  [UPDATE_STATE](state, updatedState: StateViewModel) {
    const pathToUpdate = state.currentFlow.paths.find((p) => p.id === state.currentPathId);
    if (pathToUpdate === undefined) {
      return;
    }
    const index = pathToUpdate.states.findIndex((s) => s.id === updatedState.id);
    if (index === -1) {
      return;
    }
    pathToUpdate.states.splice(index, 1, updatedState);
  },

  [REMOVE_TRANSITION](state, removeTransition: { state: StateViewModel; pathId: string }) {
    removeFromGoTo(removeTransition.state, removeTransition.pathId);
    removeFromQuickReplies(removeTransition.state, removeTransition.pathId);
    removeFromDecisions(removeTransition.state, removeTransition.pathId);
    removeFromNoMatch(removeTransition.state, removeTransition.pathId);
  },
};

function removeFromGoTo(state: StateViewModel, pathId: string) {
  if (state.transition && state.transition.payload === pathId) {
    state.transition = undefined;
    state.invalid = true;
  }
}

function removeFromQuickReplies(state: StateViewModel, pathId: string) {
  if (state.options) {
    for (const option of state.options) {
      if (option.transition && option.transition.payload === pathId) {
        option.transition = undefined;
        state.invalid = true;
      }
    }
  }
}

function removeFromDecisions(state: StateViewModel, pathId: string) {
  if (state.decisions) {
    for (const decision of state.decisions) {
      if (decision.transition && decision.transition.payload === pathId) {
        decision.transition = undefined;
        state.invalid = true;
      }
    }
  }
}

function removeFromNoMatch(state: StateViewModel, pathId: string) {
  if (state.noMatch && state.noMatch.payload === pathId) {
    state.noMatch = undefined;
    state.invalid = true;
  }
}
